import { Component, Input } from '@angular/core';
import { MatButtonModule, MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatDialog } from '@angular/material/dialog';
import { InterventionDialogComponent } from '../../pages/intervention-dialog/intervention-dialog.component';
import { IInterventionEntry } from '../../interfaces/intervention-entry-interface';
import { Bug } from '../../interfaces/bug';
import { MatSnackBar } from '@angular/material/snack-bar';
import { InterventionDbService } from '../../services/intervention_db/intervention-db.service';
import { AdoBugsService } from '../../services/bugs_service/bugs.service';
import { IInterventionDialogData } from '../../interfaces/intervention-dialog-data.interface';

@Component({
    selector: 'app-report-intervention-button',
    standalone: true,
    imports: [
        MatButtonModule,
        MatIconButton,
        MatIcon
    ],
    templateUrl: './report-intervention-button.html',
    styles: ``
})
export class ReportInterventionButtonComponent {
    @Input() bug: Bug | null = null;

    constructor(
        public dialog: MatDialog,
        public dynmoDbApiConsumerService: InterventionDbService,
        public bugService: AdoBugsService,
        private _snackBar: MatSnackBar,
    ) { }

    openDialog() {
        const data: IInterventionDialogData = {
            displayIssuegroup: !Boolean(this.bug), 
            title: this.bug ? `${this.bug.id}: ${this.bug.title}` : ''
        }

        const dialogRef = this.dialog.open(
            InterventionDialogComponent, {
            data: data
        });

        dialogRef.afterClosed().subscribe(result => {
            if (!result) {
                return;
            }

            if (this.bug) {
                (result as IInterventionEntry).BugId = this.bug.id ? String(this.bug.id) : null;
                (result as IInterventionEntry).IssueGroup = this.bug.issueGroup ? String(this.bug.issueGroup) : null;
                (result as IInterventionEntry).Description = this.bug.title ? `${String(this.bug.title)}. ${(result as IInterventionEntry).Description}`.trim() : `${(result as IInterventionEntry).Description}`;

            }
            this.openSnackBar(
                `Contacting servers to report intervention. This might take a while`,
                "Close"
            );

            this.dynmoDbApiConsumerService.createIntervention(result).subscribe(res => {
                if (!res) {
                    this.openSnackBar(
                        `Not able to report intervention in database`,
                        "Close"
                    );
                    return;
                }

                if (!this.bug) {
                    this.openSnackBar(
                        "Successfully reported intervention",
                        "Close"
                    );
                    return;
                }

                this.bugService.updateTotalDowntimeAndNumberOfReports(this.bug.id, this.bug.totalDowntime + (result.Downtime ?? 0), (this.bug.numberOfReports ?? 0) + 1).subscribe(success => {
                    if (!success) {
                        this.openSnackBar(
                            `Not able to report intervention in ADO`,
                            "Close"
                        );
                        return;
                    }
                    this.bug!.totalDowntime = this.bug!.totalDowntime + (result.Downtime ?? 0);
                    this.bug!.numberOfReports = (this.bug!.numberOfReports ?? 0) + 1;
                    this.bugService.postInterventionAsComment(result as IInterventionEntry).subscribe(success => {
                        if (success) {
                            this.openSnackBar(
                                "Successfully reported intervention",
                                "Close"
                            );
                        }
                        else {
                            this.openSnackBar(
                                `Not able to report intervention in ADO`,
                                "Close"
                            );
                        }
                    })
                });
            });
        });
    }

    openSnackBar(message: string, action: string) {
        this._snackBar.open(message, action, {
            duration: 5 * 1000, // 5 sec
        });
    }


}
